export default __webpack_public_path__ + "static/media/pound.73118801.svg";